/* eslint-disable */

'use strict';

$(function() {
  var P = require('./main.js');
  var path = BASE_URL + '/billing/cc/create/';
  var addCreditCardButtonWithoutOrgAddress = $('#add-cc-button[data-has-org-address=False]');
  var trigger = $('#add-cc-button[data-has-org-address=True],.js-subscription-create[data-charge=false]');
  var title = gettext('Add New Credit Card');
  var subTitle = gettext('Don’t worry, we’ll only charge your card for actual API usage.');

  if ($('#change-cc-button').length > 0) {
    path += '?change=true';
    trigger = $('#change-cc-button[data-has-org-address=True]');
    title = gettext('Change Credit Card');
    subTitle = undefined;

    addCreditCardButtonWithoutOrgAddress = $('#change-cc-button[data-has-org-address=False]');
  }
  if (false) {
    var stripe = Stripe(STRIPE_PUBLIC_KEY);
    var elements = stripe.elements({ fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans' }] });

    // Custom styling can be passed to options when creating an Element.
    var style = {
      base: {
        // Add your base input styles here. For example:
        fontSize: '14px',
        fontFamily: "'Open Sans', tahoma, arial, sans-serif",
        color: '#555555',
        lineHeight: '34px',
      },
    };

    // Create an instance of the card Element.
    var cardNumber = elements.create('cardNumber', { style: style });
    var cardExpiry = elements.create('cardExpiry', { style: style });
    var cardCvc = elements.create('cardCvc', { style: style });

    // Create a token or display an error when the form is submitted.
    var form = document.getElementById('js-creditcardform');
    form.addEventListener('submit', function(event) {
      event.preventDefault();
    });
  }

  P.addNewCardForm = new P.ModalForm({
    path: path,
    title: title,
    subTitle: subTitle,
    triggerElement: trigger,
    initial: window.location.search.indexOf('initial_billing') > -1,
    formContainer: $('#js-creditcardform'),
    onModalActive: function() {
      if (P.orgAddress) {
        $.each(['address', 'city', 'postal_code', 'country_code', 'state'], function(i, field) {
          $('#js-creditcardform #id_' + field).val(P.orgAddress[field] || '');
        });
      }
      P.rh_state_field($('#js-creditcardform #id_country_code'), $('#js-creditcardform #id_state'));
      // Add an instance of the card Element into the `card-element` <div>.
      cardNumber.mount('#div_id_number_input');
      cardExpiry.mount('#div_id_exp_date_input');
      cardCvc.mount('#div_id_cvv_input');
    },
    onSuccessSubmit: function() {
      window.location = window.location.origin + window.location.pathname;
    },
    onsubmit: function(e) {
      e.preventDefault();
      var self = this;

      if (this.options.formContainer.is('form')) var form = this.options.formContainer;
      else var form = this.options.formContainer.find('form');

      if (this.options.validatorConfig && !form.valid()) {
        return false;
      }

      var cardData = {
        name: $('#js-creditcardform #id_name').val(),
        address_line1: $('#js-creditcardform #id_address').val(),
        address_city: $('#js-creditcardform #id_city').val(),
        address_country: $('#js-creditcardform #id_country_code').val(),
        address_state: $('#js-creditcardform #id_state').val(),
        address_zip: $('#js-creditcardform #id_postal_code').val(),
      };

      this.setModalMessage('info', gettext('Saving data ...'));

      stripe.createToken(cardNumber, cardData).then(function(result) {
        if (result.error) {
          // Inform the customer that there was an error.
          self.setModalMessage('error', result.error.message);
        } else {
          var token = result.token;
          // Send the token to your server.
          var hiddenInput = document.createElement('input');
          hiddenInput.setAttribute('type', 'hidden');
          hiddenInput.setAttribute('name', 'token');
          hiddenInput.setAttribute('value', token.id);
          form.append(hiddenInput);

          self.onsubmit.apply(self, [e]);
        }
      });

      return false;
    },
    onClose: () => {
      if (addCreditCardButtonWithoutOrgAddress.length) {
        window.location.reload();
      }
    },
    validatorConfig: {
      rules: {
        name: {
          required: true,
          minlengthtrim: 1,
        },
        address: {
          required: true,
          minlengthtrim: 2,
        },
        city: {
          required: true,
          minlengthtrim: 2,
        },
        state: {
          required: {
            depends: function() {
              if (
                $('#js-creditcardform #id_country_code').val() === 'US' ||
                $('#js-creditcardform #id_country_code').val() === 'CA'
              ) {
                return true;
              }
              return false;
            },
          },
          requiredonly: true,
        },
        postal_code: {
          required: true,
          minlength: 2,
        },
        country_code: {
          required: true,
          depend: '#js-creditcardform #id_state',
        },
      },
      groups: {
        DateofBirth: 'exp_year exp_month',
      },
      messages: {
        first_name: {
          required: gettext('Name is required'),
        },
        company_name: {
          required: gettext('Company name is required'),
        },
        invoice_email: {
          required: gettext('Email is required'),
          email: gettext('Please enter valid email'),
        },
        country_code: {
          required: gettext('Country is required'),
          depend: gettext('Please enter a state'),
        },
        address: {
          required: gettext('Address is required'),
        },
        city: {
          required: gettext('City is required'),
        },
        state: {
          required: gettext('State is required'),
          requiredonly: gettext('State is no required'),
        },
        phone: {
          required: gettext('Phone is required'),
          digits: gettext('Invalid phone number'),
          minlength: gettext('Invalid phone number'),
        },
        postal_code: {
          required: gettext('Zip code is required'),
          minlength: gettext('Invalid zip code'),
        },
        email: {
          required: gettext('We need your email address to contact you'),
          email: gettext('Your email address must be in the format of name@domain.com'),
        },
      },
    },
  });
});
